class GiftSelector extends HTMLElement {
  static get observedAttributes() {
    return ['gift', 'types'];
  }

  connectedCallback() {
    this.setSelectorState();
    this.handleSwiper();

    document.addEventListener('cart-update', (event) => {
      this.isFreeProductPickingAllowed(event.detail);
    });
  }

  setSelectorState() {
    const giftStatus = this.getAttribute('gift');
    switch (giftStatus) {
      case 'not-allowed':
        this.classList.remove('in-cart', 'not-in-cart');
        this.classList.add('not-allowed');
        break;
      case 'in-cart':
        this.classList.remove('not-in-cart', 'not-allowed');
        this.classList.add('in-cart');
        break;
      default:
        this.classList.remove('not-allowed', 'in-cart');
        this.classList.add('not-in-cart');
        break;
    }
  }

  handleSwiper() {
    this.swiperInstance = this.querySelector('swiper-slider [data-swiper]');

    // Wait for swiper to be initialized before setting total index
    if (this.swiperInstance?.swiper) {
      this.setSwiperTotalIndex();
    } else {
      // If swiper isn't ready yet, wait for it
      const checkSwiper = setInterval(() => {
        if (this.swiperInstance?.swiper) {
          this.setSwiperTotalIndex();
          clearInterval(checkSwiper);
        }
      }, 100);
      // Clear interval after 5 seconds to avoid infinite loop
      setTimeout(() => clearInterval(checkSwiper), 5000);
    }

    window.addEventListener('resize', () => {
      this.setSwiperTotalIndex();
    });
    this.swiperInstance?.swiper?.on('activeIndexChange', (event) => {
      this.querySelector('[data-swiper="active-index"]').textContent = event.snapIndex + 1;
    });
    this.swiperInstance?.swiper?.on('reachEnd', (event) => {
      console.log('reachEnd');
      console.log(event);
      this.querySelector('[data-swiper="active-index"]').textContent = event.snapGrid.length;
      // Also update total index when reaching end to ensure it's correct
      this.setSwiperTotalIndex();
    });
    // Update total index when swiper is ready
    this.swiperInstance?.swiper?.on('init', () => {
      this.setSwiperTotalIndex();
    });
  }

  setSwiperTotalIndex() {
    const totalIndex = this.swiperInstance?.swiper?.snapGrid?.length;
    const totalIndexElement = this.querySelector('[data-swiper="total-index"]');
    if (totalIndexElement && totalIndex) {
      totalIndexElement.textContent = totalIndex;
    }
  }

  attributeChangedCallback() {
    this.setSelectorState();
  }

  isFreeProductPickingAllowed(cart) {
    const line_items_gift_card = cart.items.filter(
      (item) => item.gift_card === true && item.requires_shipping === false
    );
    const line_items_normal = cart.items.filter(
      (item) =>
        item.gift_card === false &&
        item.requires_shipping === true &&
        '_gift' in item.properties === false
    );

    const is_gift_in_cart = cart.items.some(
      (item) => item.properties && '_gift' in item.properties
    );

    if (is_gift_in_cart) {
      this.setAttribute('gift', 'in-cart');
    } else if (line_items_normal.length > 0) {
      this.setAttribute('gift', 'not-in-cart');
    } else if (line_items_gift_card.length > 0 && line_items_normal.length === 0) {
      this.setAttribute('gift', 'not-allowed');
    }
  }
}

customElements.define('gift-selector', GiftSelector);
